import React from 'react';

const variants = {
  default: 'bg-blue-600 text-white',
  secondary: 'bg-gray-200 text-gray-900',
  destructive: 'bg-red-600 text-white',
  outline: 'border border-gray-300 text-gray-900 bg-transparent',
};

export const Badge = ({ className = '', variant = 'default', ...props }) => {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${variants[variant] || variants.default} ${className}`}
      {...props}
    />
  );
};
